export default {
  moedas: {
    EUR: 'EUR',
    USD: 'USD',
  },
  cotacao: {
    EUR: {
      data: null,
      cotacao: null,
    },
    USD: {
      data: null,
      cotacao: null,
    },
  },
  tiposMoedas: [
    {
      label: 'BRL - REAL/BRASIL',
      value: 'BRL',
    },
    {
      label: 'EUR - EURO/COM.EUROPEIA',
      value: 'EUR',
    },
    {
      label: 'USD - DOLAR DOS EUA',
      value: 'USD',
    },
    {
      label: 'AUD - DOLAR AUSTRALIANO',
      value: 'AUD',
    },
    {
      label: 'CAD - DOLAR CANADENSE',
      value: 'CAD',
    },
    {
      label: 'NZD - DOLAR/NOVA ZELAND',
      value: 'NZD',
    },
    {
      label: 'GBP - LIBRA ESTERLINA',
      value: 'GBP',
    },
    {
      label: 'CHF - FRANCO SUICO',
      value: 'CHF',
    },
    {
      label: 'SEK - COROA SUECA',
      value: 'SEK',
    },
    {
      label: 'NOK - COROA NORUEGUESA',
      value: 'NOK',
    },
    {
      label: 'PAB - BALBOA/PANAMA',
      value: 'PAB',
    },
    {
      label: 'KRW - WON COREIA SUL',
      value: 'KRW',
    },
    {
      label: 'JPY  - IENE',
      value: 'JPY',
    },
    {
      label: 'ARS  - PESO ARGENTINO',
      value: 'ARS',
    },
    {
      label: 'RUB  - RUBLO/RUSSIA',
      value: 'RUB',
    },
    {
      label: 'INR  - RUPIA/INDIA',
      value: 'INR',
    },
  ],
};
